module.exports = __webpack_public_path__ + "img/about-persist.7fef7a9c.jpg";